import { Tooltip } from 'antd'
import React from 'react'
import { info_cicrle } from './ExportImgFigma'

interface props {
    value: string
}

const TooltipComponent: React.FC<props> = ({
    value
}) => {
    return (
        < Tooltip
            placement="right"
            color="white"
            title={
                <div
                    style={{
                        maxHeight: 400,       // chiều cao cố định
                        overflowY: "auto",    // bật scroll dọc
                    }}
                    className="space-y-2"
                >
                    <div className="custom-page-css flex items-center gap-2 h-fit" >
                        <span className="color-bage-custom fs-14">
                            {value}
                        </span>
                    </div>
                </div>
            }
        >
            <div className="action-icons action-icons-bage ml-auto px-1 fs-14 cursor-pointer custom-page-css h-fit">
                <img src={info_cicrle} alt="Avatar" />
            </div>
        </Tooltip>
    )
}

export default TooltipComponent